import React, {useMemo, useState} from 'react';
import Currency from "../Utils/Number/Currency";
import DateFormated from "../Utils/Date/Date";
import {useTranslation} from "react-i18next";
import BasicDataTable from "../Utils/BasicDataTable";
import FixedDataTable from "./Fix/FixedDataTable";
import {fireGTMDownloadFileEvent} from "../Utils/GTM/GTMHelper";

const ByFix = (props) => {
    const {t, i18n} = useTranslation();
    let descAccessor = ((i18n.language === 'fr') ? 'descriptionFr' : 'descriptionEn');
    let customBalance = props.customBalance;

    const columns = useMemo(
        () => [
            {
                Header: t("docs.invoices.table.headers.accountbilled"),
                accessor: "subAccountName",
                disableSortBy: true,
                Cell: (props) => {
                    return (
                        <React.Fragment>
                            <strong>
                                {props.value != "" ? props.value : props.row.original.accountName} - {props.row.original.subAccountCode}
                            </strong>
                            <br/>
                            <small>
                                {Object.values(props.row.original.subAccountAddress)
                                    .filter((el) => {
                                        return el != null && el !== "";
                                    })
                                    .join(", ")}
                            </small>
                        </React.Fragment>
                    );
                },
            }, {
                Header: t('docs.invoices.table.headers.invoice_no'),
                accessor: 'invoiceNumber',
                Cell: (props) => {
                    return (props.value) ? props.value : '';
                },
            }, {
                id: "statementdate",
                Header: t("docs.invoices.table.headers.statementdate"),
                accessor: "statementDate",
                Cell: (props) => {
                    if (props.value) {
                        return (
                            <DateFormated date={props.value} withTime={false}/>
                        );
                    } else {
                        return "";
                    }
                },

            }, {
                id: "dueDate",
                Header: t("docs.invoices.table.headers.payment_due_date"),
                accessor: "dueDate",
                sort: "desc",
                Cell: (props) => {
                    if (props.value) {
                        return (
                            <DateFormated date={props.value} withTime={false}/>
                        );
                    } else {
                        return "";
                    }
                },
                sortMethod: (a, b) => {
                    var a1 = new Date(a).getTime();
                    var b1 = new Date(b).getTime();
                    if (a1 < b1) return 1;
                    else if (a1 > b1) return -1;
                    else return 0;
                },
            }, {
                Header: t('docs.invoices.table.headers.status'),
                accessor: 'transactionStatus.' + descAccessor,
                Cell: (props) => {
                    return (props.value) ? props.value : '';
                },
            }, {
                Header: t('docs.invoices.table.headers.po'),
                accessor: 'purchaseOrderNumber',
                Cell: (props) => {
                    return (props.value) ? props.value : '';
                },
            }, {
                Header: t('dashboard.subaccounts.table.header.balancedue'),
                accessor: 'balanceAmount.value',
                Cell: (props) => {
                    if (customBalance.length !== 0) {
                        let element = customBalance.find(elem => elem.invoiceNumber === props.row.values.invoiceNumber);
                        if (element !== undefined) {
                            return <React.Fragment>
                                <Currency value={element.amount}/>
                                <br/>
                                <strong className="span--c-red">
                                    {element.remaining === 0 ?
                                        <Currency value={-(element.amount)}/> :
                                        element.remaining >= 0 ? <Currency value={-(element.amount)}/> :
                                            (element.amount + element.remaining !== 0) &&
                                            <Currency value={-(element.amount + element.remaining)}/>
                                    }
                                </strong><br/>
                            </React.Fragment>
                        } else {
                            return (props.value) ? <Currency value={props.value}/> : ''
                        }
                    } else {
                        return (props.value) ? <Currency value={props.value}/> : ''
                    }
                },
            }, {
                Header: () => null,
                id: "file", // 'id' is required
                accessor: "documentPath",
                Cell: (props) => {
                    if (props.value) {
                        return (
                            <a
                                href={`/rest/v1/communications/download?filename=${encodeURI(
                                    props.value
                                )}`}
								onClick={()=>fireGTMDownloadFileEvent('facture', 'PDF')}
                                target="_blank"
                                className="link link--red link--upper link--accent link--fs-14"
                            >
                                <i className="far fa-file-download fa-2x"></i>
                            </a>
                        );
                    } else {
                        return "";
                    }
                }
            },
        ],
        [t, i18n, props.data, props.customBalance]
    );

    return (
        <React.Fragment>
            <FixedDataTable columns={columns} data={props.data}/>
        </React.Fragment>
    )
};

export default ByFix;
